import React from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const IncludeHeadersOption = props => {
	const { widgetToUpdate, handleChange, event, handleGroupChange, targetKeys, children } = props;

	return (
		<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
			{children}
			<Form.Item label="Include Widget Headers?" name="include_headers">
				<Form.TwoOptionSelect />
			</Form.Item>
			<WidgetOptionGroupPermissions
				event={event}
				handleGroupChange={handleGroupChange}
				targetKeys={targetKeys}
			/>
		</WidgetOptionsForm>
	);
};

export default IncludeHeadersOption;
